module.exports = __webpack_public_path__ + "img/exit-to-app.753654a1.svg";